import { jsx as r } from "react/jsx-runtime";
import { c as t } from "../../index-C3-ZVs5E.js";
import { t as n } from "../../bundle-mjs-kGHm2Pod.js";
import { SpinnerThemeEnum as p } from "./types.js";
import '../../assets/Spinner.css';const i = "_spinner_tpurh_2", o = "_path_tpurh_7", e = {
  spinner: i,
  path: o
}, _ = ({
  theme: s = p.primary,
  className: a
}) => /* @__PURE__ */ r(
  "span",
  {
    className: n("app:w-8 app:h-8 app:relative", a),
    role: "status",
    children: /* @__PURE__ */ r("svg", { className: e.spinner, viewBox: "0 0 50 50", children: /* @__PURE__ */ r(
      "circle",
      {
        className: t(e.path, {
          "app:stroke-primary": s === p.primary,
          "app:stroke-neutral": s === p.negated
        }),
        cx: "25",
        cy: "25",
        r: "20",
        fill: "none",
        strokeWidth: "5"
      }
    ) })
  }
);
export {
  _ as Spinner
};
